import { Badge } from 'components/Badge/Badge';
import { useTranslation } from 'react-i18next';

export const FullEvent = ({ event }: any) => {
    const { t } = useTranslation('events');
    const totalParticipants = event.totalNumberOfInvitees || event.confirmed?.totalCount;
    if (event.capacity === totalParticipants) {
        return <Badge className="hover:bg-zinc-700 h-[20px]">{t('full')}</Badge>;
    }
    return null;
};
